import TableCellTruncated from "../../../common/components/table/TableCellTruncated";

interface ICountDeltaProps {
  delta: string | null | undefined;
}

const CountDelta = ({ delta }: ICountDeltaProps) => {
  let deltaLabel = delta;

  if (!delta || delta === "0") {
    deltaLabel = "";
  }

  const positiveDelta = Number(deltaLabel) > 0;

  return (
    <TableCellTruncated
      tooltipText={""}
      text={positiveDelta ? `+${deltaLabel}` : deltaLabel ?? ""}
      TypographyProps={{
        variant: "body2",
        color: positiveDelta ? "primary.main" : "error.main",
        fontWeight: 600,
      }}
    />
  );
};

export default CountDelta;
